<template>
    <div class="page-column">
      <Header/>
      <MatchInfo />
      <MatchMenu />
      <MatchAgency />
      <Footer/>
    </div>
  </template>
  
<script>
import Header from '@district/components/common/MatchHeader.vue'
import Footer from '@district/components/common/Footer'
import MatchInfo from '@comm/components/MatchInfo.vue'
import MatchMenu from '@comm/components/MatchMenu.vue'
import MatchAgency from '@comm/components/MatchAgency.vue'
export default {
  components: {
    Header,
    MatchInfo,
    MatchMenu,
    MatchAgency,
    Footer
  },
  data () {
    return {
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {
  },
  methods: {
  }
}
</script>
  <style lang="scss" scoped>
  .page-column {
    width: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/district/views/project/components/Agency.vue